(() => {
  const init = () => {
    document.querySelectorAll('[data-ckl-native-nav]').forEach((nav) => {
      if (nav.dataset.ready === 'true') return;
      nav.dataset.ready = 'true';
      const desktop = window.matchMedia('(min-width: 1200px)');
      const triggers = Array.from(nav.querySelectorAll('[data-ckl-menu-trigger]'));
      let active = null;
      let timer = 0;
      const panelFor = (trigger) => document.getElementById(trigger.getAttribute('aria-controls'));
      const announce = (open) => nav.dispatchEvent(new CustomEvent('desktop-nav:dropdown:' + (open ? 'open' : 'close'), { bubbles: true }));
      const position = () => {
        if (active) nav.style.setProperty('--ckl-native-menu-top', Math.max(0, active.getBoundingClientRect().bottom) + 'px');
      };
      const close = (restoreFocus = false) => {
        window.clearTimeout(timer);
        if (!active) return;
        const trigger = active;
        const panel = panelFor(trigger);
        trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
        active = null;
        announce(false);
        if (restoreFocus) trigger.focus();
      };
      const open = (trigger, focusFirst = false) => {
        window.clearTimeout(timer);
        if (!desktop.matches) return;
        const panel = panelFor(trigger);
        if (!panel) return;
        if (active && active !== trigger) close();
        active = trigger;
        position();
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        announce(true);
        if (focusFirst) panel.querySelector('a, button')?.focus();
      };
      triggers.forEach((trigger) => {
        const item = trigger.closest('.ckl-native-nav__item');
        const panel = panelFor(trigger);
        if (!item || !panel) return;
        item.addEventListener('pointerenter', (event) => { if (event.pointerType !== 'touch') open(trigger); });
        item.addEventListener('pointerleave', () => { timer = window.setTimeout(() => close(), 140); });
        panel.addEventListener('pointerenter', () => window.clearTimeout(timer));
        trigger.addEventListener('click', (event) => {
          if (active !== trigger) { event.preventDefault(); open(trigger); }
        });
        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown' || event.key === ' ') { event.preventDefault(); open(trigger, true); }
          else if (event.key === 'Escape') { event.preventDefault(); close(true); }
        });
        panel.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') { event.preventDefault(); close(true); return; }
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          const links = Array.from(panel.querySelectorAll('a'));
          const current = links.indexOf(document.activeElement);
          if (current < 0) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? links.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + links.length) % links.length;
          links[next]?.focus();
        });
      });
      nav.addEventListener('focusout', () => window.setTimeout(() => { if (!nav.contains(document.activeElement)) close(); }, 0));
      document.addEventListener('pointerdown', (event) => { if (!nav.contains(event.target)) close(); });
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && active) close(true); });
      window.addEventListener('resize', () => { if (!desktop.matches) close(); else position(); }, { passive: true });
      window.addEventListener('scroll', position, { passive: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
